
const setEmpresa = (context,empresa) => {
	context.commit('SET_EMPRESA', empresa);
}

const setPeriodico = (context, periodico) => {
	context.commit('SET_PERIODICO', periodico);
}

export{
	setEmpresa,
	setPeriodico
}



// WEBPACK FOOTER //
// ./src/store/empresa/actions.js